// import axios from '../plugins/axios'
export default class getLocalStorage {

  user() {
    var user = [];
    user = JSON.parse(localStorage.getItem('user'));
    return user;
  }

  pp() {
    if (localStorage.getItem('datapp') === null) {
      return {
        ppid: '',
        namapp: ''
      }
    } else {
      return {
        ppid: JSON.parse(localStorage.getItem('datapp')).ppid.toString(),
        namapp: JSON.parse(localStorage.getItem('datapp')).namapp.toString()
      }
    }
  }

  po() {
    if (localStorage.getItem('datapo') === null) {
      return {
        poid: '',
        namapo: ''
      }
    } else {
      return {
        poid: JSON.parse(localStorage.getItem('datapo')).poid.toString(),
        namapo: JSON.parse(localStorage.getItem('datapo')).namapo.toString()
      }
    }
  }

  checkpppo() {
    let checkpppo = 0
    if (localStorage.getItem('datapp') === null) {
      checkpppo++
    }
    if (localStorage.getItem('datapo') === null) {
      checkpppo++
    }
    return checkpppo
  }

  setHID(hidData) {
    ////////////check kalau dah ada hid//////////////
    if (localStorage.getItem("hid") === null) {
      window.localStorage.setItem('hid', JSON.stringify(hidData));
    } else {
      window.localStorage.removeItem('hid');//remove previous hid data
      window.localStorage.setItem('hid', JSON.stringify(hidData));//set current hid data
    }

  }

  getHIDdata() {
    var dataHID = [];
    dataHID = JSON.parse(localStorage.getItem('hid'));
    return dataHID;
  }


  setCurrentNOAIRData(currNOAIRData) {

    ////////////check kalau dah ada NOAIR//////////////
    if (localStorage.getItem("currNOAIRData") === null) {
      window.localStorage.setItem('currNOAIRData', JSON.stringify(currNOAIRData));
    } else {

      window.localStorage.removeItem('currNOAIRData');
      window.localStorage.setItem('currNOAIRData', JSON.stringify(currNOAIRData));
    }

  }

  getCurrentNOAIRData() {
    var currNOAIRData = '';
    currNOAIRData = JSON.parse(localStorage.getItem('currNOAIRData'));
    return currNOAIRData;
  }

  // getCurrentJUMBELANJAData() {
  //   var currJUMBELANJAData = '';
  //   currJUMBELANJAData = JSON.parse(localStorage.getItem('currJUMBELANJAData'));
  //   return currJUMBELANJAData;
  // }

}